import { environment } from 'environments';

(() => {
  class QuestionnaireDetailController {
    constructor(
      $scope,
      $state,
      $stateParams,
      $timeout,
      ngDialog,
      toastr,
      Services,
      QuestionnaireService,
      Utils,
      API_URL,
      $q,
      ComboQuestionService,
    ) {
      'ngInject';

      Object.assign(this, {
        $state,
        $stateParams,
        ngDialog,
        toastr,
        Services,
        QuestionnaireService,
        Utils,
        API_URL,
        $q,
        ComboQuestionService,
        LMNUK_1695: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        canHaveChildQuestion: FEATURE_BODACDC_2929 ? ['select', 'gp_address_docman'] : ['select'],
        BOD_2690: [].includes(environment.constants.ENV),
        serviceId: $stateParams.serviceId,
        questionnaireId: $stateParams.questionnaireId,
        phases: ['draft', 'test', 'published'],
        sectionSortableOptions: {
          handle: '.section-handle',
          stop: (event, ui) => {
            const sections = ui.item.sortable.sourceModel;
            const sectionIds = sections.map(s => s.id);

            // IF SECTIONS ARE REORDERED
            // THEN WE UPDATE THE SECTION INDEX NUMBER

            var index = 0;

            if (this.q && this.q.sections && this.q.sections.length) {
              this.q.sections.forEach(section => {
                section.index = index + 1;
                index++;
              });
            }

            this.updateSectionPositions(sectionIds);
          },
        },
        questionSortableOptions: {
          handle: '.question-handle',
          stop: (event, ui) => {
            const questions = ui.item.sortable.sourceModel;
            var questionIds = questions.map(q => q.id);
            const sectionId = questions[0].section_id;

            // WE MAKE SURE THE PARENT QUESTION
            // KEEPS IN THE TOP OF THE SECTION
            // AFTER ANY UI SORTING
            var parentQuestion = this.getParentQuestion(questions);

            if (parentQuestion) {
              var index = questionIds.indexOf(parentQuestion.id);
              if (index > 0) {
                questionIds.splice(index, 1);
                questionIds.unshift(parentQuestion.id);
              }

              if (this.q && this.q.sections && this.q.sections.length) {
                this.q.sections.forEach(section => {
                  if (section.id == sectionId) {
                    var sectionToSort = section;
                    if (sectionToSort.questions && sectionToSort.questions.length) {
                      var index = sectionToSort.questions.findIndex(x => x.id == parentQuestion.id);
                      if (index > 0) {
                        sectionToSort.questions.splice(index, 1);
                        sectionToSort.questions.unshift(parentQuestion);
                        section = sectionToSort;
                      }
                    }
                  }
                });
              }
            }

            this.updateQuestionPositions(sectionId, questionIds);
          },
        },
        answerSortableOptions: {
          handle: '.answer-handle',
          stop: (event, ui) => {
            const answers = ui.item.sortable.sourceModel;
            const answerIds = answers.map(a => a.id);
            const questionId = answers[0].question_id;

            this.updateAnswerPositions(questionId, answerIds);
          },
        },

        warningLevel: [
          { name: 'Normal', type: 0 },
          { name: 'Information', type: 1 },
          { name: 'Warning', type: 2 },
          //{ name: 'MD to Query', type: 4 },
          { name: 'MD to Query', type: 2.5 },
          { name: 'Danger', type: 3 },
        ],
        answerDetailTypes: ['address', 'text'],
      });

      this.init();
    }

    init() {
      this.getAllServices();

      this.Services.fetch(this.serviceId)
        .then(({ data: service }) => {
          this.service = service;
          return this.QuestionnaireService.fetch(this.$stateParams.questionnaireId);
        })
        .then(({ data: questionnaire }) => {
          this.q = new Questionnaire(questionnaire, this.service);
          this.updateRelationships();
        });
    }

    getAllServices() {
      this.Services.list()
        .then(({ data }) => {
          let servicesArr = [];

          for (let i = 0; i < data.data.length; i++) {
            if (data.data[i].children) {
              for (let j = 0; j < data.data[i].children.length; j++) {
                servicesArr.push({
                  id: data.data[i].children[j].id,
                  code: data.data[i].children[j].code,
                  name: data.data[i].children[j].name + ' (' + data.data[i].children[j].code + ')',
                });
              }
              continue;
            }
            servicesArr.push({
              id: data.data[i].id,
              code: data.data[i].code,
              name: data.data[i].name + ' (' + data.data[i].code + ')',
            });
          }

          servicesArr.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });

          var elem = { id: 0, code: 'SELECT', name: 'Select a service' };
          servicesArr.unshift(elem);
          this.services = servicesArr;
          this.selectedService = elem;
        })
        .catch(err => {
          this.services = [];
          this.toastr.error('Error getting all services: ' + JSON.stringify(err));
        });
    }

    cloneToOtherService() {
      if (this.selectedService.code === 'SELECT') {
        this.toastr.warning('Please choose a service');
        return;
      }
      this.QuestionnaireService.cloneToOtherService(this.q.id, this.selectedService.code)
        .then(({ data: q }) => {
          this.$state.go('cms.questionnaireDetail', {
            serviceId: this.selectedService.id,
            questionnaireId: q.id,
          });
        })
        .catch(err => {
          return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not clone questionnaire.'));
        });
    }

    clonToOtherService() {
      if (this.selectedService.code == 'SELECT') {
        this.toastr.warning('Please chooose a service');
        return;
      }

      this.QuestionnaireService.clonToOtherService(this.q.id, this.selectedService.code)
        .then(({ data: q }) => {
          this.$state.go('cms.questionnaireDetail', {
            serviceId: this.selectedService.id,
            questionnaireId: q.id,
          });
        })
        .catch(err => {
          return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not clone questionnaire.'));
        });
    }

    replaceDotForDash(warning_level) {
      return this.Utils.replaceDotForDash(warning_level);
    }

    updateRelationships() {
      var index = 0;

      this.q.sections.forEach(section => {
        section.index = index + 1;
        index++;

        section.questions.forEach(question => {
          question.section_id = section.id;
          question.answers.forEach(answer => {
            answer.question_id = question.id;
          });
        });
      });
    }

    doesSectionHaveParentQuestion(section) {
      var hasParent = false;

      if (!section.questions || !section.questions.length) return false;

      section.questions.forEach(question => {
        if (!question.display_condition) hasParent = true;
      });

      return hasParent;
    }

    getParentQuestion(questions) {
      var parentQuestion = null;

      if (!questions || !questions.length) return null;

      questions.forEach(question => {
        if (!question.display_condition) parentQuestion = question;
      });

      return parentQuestion;
    }

    showAddQuestion(section) {
      var parentQuestion = this.getParentQuestion(section.questions);

      if (!parentQuestion) return true;
      //TODO: Harold - combo question second iteration child question creation
      // if (this.LMNUK_1695) {
      //   return ['select', 'select_combo'].includes(parentQuestion.type)
      // }

      return this.canHaveChildQuestion.includes(parentQuestion.type);
    }

    getQuestionLabel(question, section) {
      if (!question.display_condition) return 'PARENT ' + section.index;

      if (section.questions && section.questions.length) {
        var index = 0;
        section.questions.forEach(q => {
          q.index = index;
          if (question.id == q.id) question.index = index;
          index++;
        });
      }

      var label = 'CHILD ' + section.index + String.fromCharCode(64 + question.index);
      var answersList = '';
      var parentQuestion = this.getParentQuestion(section.questions);

      if (parentQuestion && question.display_condition.options && question.display_condition.options.length) {
        question.display_condition.options.forEach(option => {
          if (parentQuestion.answers && parentQuestion.answers.length) {
            var answer = parentQuestion.answers.find(x => x.id == option);
            if (answer) {
              if (answersList) {
                answersList = answersList + ', ' + answer.text;
              } else {
                answersList = answer.text;
              }
            }
          }
        });
      }

      if (answersList) label = label + ' - ' + answersList;

      return label;
    }

    updatePhase(phase) {
      if (!this.checkFastTrackQuestions()) {
        this.toastr.error(
          'Invalid fast_track question, please check the answers have 2 options: Yes and No with one possible selection only',
        );
        return;
      } else if (this.BOD_2690 && this.isQuestionnaireInvalidWithShowError()) {
        return;
      }

      this.QuestionnaireService.update(this.q.id, { phase })
        .then(() => {
          this.q.phase = phase;
        })
        .catch(err => {
          return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update questionnaire phase.'));
        });
    }

    clone() {
      this.QuestionnaireService.cloneQuestionnaire(this.q.id)
        .then(({ data }) => {
          this.$state.go('cms.questionnaireDetail', {
            serviceId: this.serviceId,
            questionnaireId: data.id,
          });
        })
        .catch(err => {
          return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not clone questionnaire.'));
        });
    }

    delete() {
      this.QuestionnaireService.delete(this.q.id)
        .then(() => {
          this.$state.go('cms.service', { serviceId: this.serviceId });
        })
        .catch(err => {
          this.Utils.getApiErrorMessage(err, 'Failed to delete questionnaire.');
        });
    }

    editQuestionnaire() {
      this.ngDialog.open({
        template: 'app/views/services/questionnaire/questionnaire-form.tpl.html',
        data: { editing: true, questionnaire: Object.assign({}, this.q) },
        preCloseCallback: (editedQuestionnaire = {}) => {
          if (_.isObject(editedQuestionnaire)) {
            this.QuestionnaireService.update(this.q.id, editedQuestionnaire)
              .then(() => {
                Object.assign(this.q, editedQuestionnaire);
              })
              .catch(err => {
                return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update section.'));
              });
          }
        },
      });
    }

    updateStagingQuestionnaire() {
      this.Services.update(this.serviceId, { staged_questionnaire_id: this.q.id })
        .then(() => {
          this.service.staged_questionnaire_id = this.q.service.staged_questionnaire_id = this.q.id;
          this.toastr.success('Staging questionnaire updated.');
        })
        .catch(err => {
          return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update staged questionnaire.'));
        });
    }

    checkFastTrackQuestions() {
      for (let i = 0; i < this.q.sections.length; i++) {
        const section = this.q.sections[i];

        for (let j = 0; j < section.questions.length; j++) {
          const question = section.questions[j];

          if (question.type === 'fast_track') {
            if (question.answers.length !== 2 || question.max !== 1) {
              return false;
            }

            let check = false;
            const firstOption = question.answers[0].text.toLowerCase();
            const secondOption = question.answers[1].text.toLowerCase();

            if (firstOption === 'yes' && secondOption === 'no' && !question.answers[1].details) {
              check = true;
            } else if (firstOption === 'no' && !question.answers[0].details && secondOption === 'yes') {
              check = true;
            }
            if (!check) {
              return false;
            }
          }
        }
      }
      return true;
    }

    makeServiceQuestionnaire() {
      if (!this.q.published) {
        this.toastr.error('The questionnaire must be marked verified before going live.');
        return;
      }

      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: 'Make Service Questionnaire',
          content: `Are you sure you want to assign to ${this.service.display_name}`,
        },
      };

      this.ngDialog.openConfirm(config).then(() => {
        this.Services.update(this.serviceId, { questionnaire_id: this.q.id })
          .then(() => {
            this.service.questionnaire_id = this.q.service.questionnaire_id = this.q.id;
            this.toastr.success('Live questionnaire updated.');
          })
          .catch(err => {
            return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update live questionnaire.'));
          });
      });
    }

    /**
     * SECTIONS
     */
    addSection() {
      if (this.BOD_2690 && this.isQuestionnaireInvalidWithShowError()) {
        return;
      }
      this.ngDialog.open({
        template: 'app/views/services/questionnaire/section-form.tpl.html',
        preCloseCallback: (newSection = {}) => {
          if (_.isObject(newSection)) {
            this.QuestionnaireService.addSection(this.questionnaireId, newSection)
              .then(({ data: savedSection }) => {
                this.q.sections.push(savedSection);
                this.updateRelationships();
              })
              .catch(err => {
                return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not create section.'));
              });
          }
        },
      });
    }

    editSection(oldSection) {
      this.ngDialog.open({
        template: 'app/views/services/questionnaire/section-form.tpl.html',
        data: { editing: true, section: Object.assign({}, oldSection) },
        preCloseCallback: (editedSection = {}) => {
          if (_.isObject(editedSection)) {
            delete editedSection.questions;
            this.QuestionnaireService.updateSection(editedSection)
              .then(() => {
                Object.assign(oldSection, editedSection);
              })
              .catch(err => {
                return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update section.'));
              });
          }
        },
      });
    }

    deleteSection(section, index) {
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: { title: 'Delete Section', content: 'Are you sure you want to delete this section?' },
      };

      this.ngDialog.openConfirm(config).then(() => {
        this.QuestionnaireService.deleteSection(section.id)
          .then(() => {
            this.q.sections.splice(index, 1);
          })
          .catch(err => {
            return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not delete section.'));
          });
      });
    }

    updateSectionPositions(sectionIds) {
      this.QuestionnaireService.updateSectionPositions(this.questionnaireId, sectionIds).catch(err => {
        return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update section ordering.'));
      });
    }

    getParentAnswers(parentQuestion) {
      var parentAnswers = [];

      if (this.LMNUK_1695) {
        if (
          parentQuestion &&
          parentQuestion.answers &&
          parentQuestion.answers.length &&
          parentQuestion.type !== 'select_combo'
        ) {
          parentQuestion.answers.forEach(answer => {
            answer.short_text = answer.text.substring(0, 50);
          });
          parentAnswers = parentQuestion.answers;
        } else if (parentQuestion && parentQuestion.type === 'select_combo' && parentQuestion.additional_fields) {
          parentQuestion.additional_fields.map(answer => {
            const displayAnswer = this.ComboQuestionService.formatDisplayedExpression(
              parentQuestion.answers,
              answer.attributes.expression,
            );
            answer.short_text = displayAnswer.substring(0, 50);
            answer.text = `<i class="icon-dot status-${this.replaceDotForDash(answer.attributes.status)} m-r-xs"></i>${displayAnswer}`;
          });
          parentAnswers = parentQuestion.additional_fields;
          parentAnswers.sort((a, b) => a.attributes.status - b.attributes.status);
        }
      } else {
        if (parentQuestion && parentQuestion.answers && parentQuestion.answers.length) {
          parentQuestion.answers.forEach(answer => {
            answer.short_text = answer.text.substring(0, 50);
          });
          parentAnswers = parentQuestion.answers;
        }
      }
      return parentAnswers;
    }

    /**
     * QUESTIONS
     */

    addQuestion(parentSection) {
      let isChildQuestion = this.doesSectionHaveParentQuestion(parentSection);
      var parentQuestion = this.getParentQuestion(parentSection.questions);
      var parentAnswers = this.getParentAnswers(parentQuestion);

      if (this.BOD_2690 && isChildQuestion && this.isQuestionnaireInvalidWithShowError()) {
        return;
      }

      this.ngDialog.open({
        template: 'app/views/services/questionnaire/question-form.tpl.html',
        ...(this.BOD_2690 && { trapFocus: false }),
        ...(this.BOD_2690 && { className: 'ngdialog-theme-default questionnaire-question-dialog' }),
        controller: 'QuestionController',
        controllerAs: 'quest',
        data: {
          mailOrderValues: [
            { name: 'Active', type: 'mailorder' },
            { name: 'Inactive', type: null },
          ],

          parentQuestion: parentQuestion,
          parentAnswers: parentAnswers,
          isParentQuestion: !this.doesSectionHaveParentQuestion(parentSection),
          question: { required: true },
        },

        preCloseCallback: (args = {}) => {
          const newQuestion = args.newQuestion;

          if (_.isObject(newQuestion)) {
            if (['blood_pressure', 'blood_pressure_uk'].includes(newQuestion.type)) {
              newQuestion.additional_fields = {
                systolic_title: 'Systolic',
                diastolic_title: 'Diastolic',
              };
            }

            if (
              [
                'bmi',
                'bmi_weight',
                'bmi_cocp_nor',
                'bmi_pde_pro',
                'bmi_map_lev1',
                'bmi_map_lev2',
                'bmi_map_uli',
                'bmi_wei',
                'bmi_wei_r',
                'bmi_meno',
              ].includes(newQuestion.type)
            ) {
              newQuestion.additional_fields = {
                system_title: 'System',
                height_title: 'Height',
                weight_title: 'Weight',
              };
            }

            if (newQuestion.tag === '') newQuestion.tag = null;

            this.QuestionnaireService.addQuestion(parentSection.id, newQuestion)
              .then(({ data: question }) => {
                parentSection.questions.push(question);
                this.updateRelationships();
              })
              .catch(err => {
                return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not add question.'));
              });
          }
        },
      });
    }

    editQuestion(oldQuestion, parentSection) {
      var parentQuestion = this.getParentQuestion(parentSection.questions);
      var parentAnswers = this.getParentAnswers(parentQuestion);

      this.ngDialog.open({
        template: 'app/views/services/questionnaire/question-form.tpl.html',
        ...(this.BOD_2690 && { trapFocus: false }),
        ...(this.BOD_2690 && { className: 'ngdialog-theme-default questionnaire-question-dialog' }),
        controller: 'QuestionController',
        controllerAs: 'quest',
        data: {
          mailOrderValues: [
            { name: 'Active', type: 'mailorder' },
            { name: 'Inactive', type: null },
          ],

          parentQuestion: parentQuestion,
          parentAnswers: parentAnswers,
          isParentQuestion: !oldQuestion.display_condition ? true : false,
          editing: true,
          question: Object.assign({}, oldQuestion),
        },

        preCloseCallback: (args = {}) => {
          const editedQuestion = args.newQuestion;

          if (_.isObject(editedQuestion)) {
            if (['blood_pressure', 'blood_pressure_uk'].includes(editedQuestion.type)) {
              editedQuestion.additional_fields = {
                systolic_title: 'Systolic',
                diastolic_title: 'Diastolic',
              };
            }

            if (
              [
                'bmi',
                'bmi_weight',
                'bmi_cocp_nor',
                'bmi_pde_pro',
                'bmi_map_lev1',
                'bmi_map_lev2',
                'bmi_map_uli',
                'bmi_wei',
                'bmi_wei_r',
                'bmi_meno',
              ].includes(editedQuestion.type)
            ) {
              editedQuestion.additional_fields = {
                system_title: 'System',
                height_title: 'Height',
                weight_title: 'Weight',
              };
            }

            delete editedQuestion.answers;

            if (editedQuestion.tag === '') editedQuestion.tag = null;

            if (!editedQuestion.description) editedQuestion.description = '';

            this.QuestionnaireService.updateQuestion(oldQuestion.id, editedQuestion)
              .then(() => {
                Object.assign(oldQuestion, editedQuestion);
              })
              .catch(err => {
                return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update question.'));
              });
          }
        },
      });
    }

    deleteQuestion(questions, question, index) {
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: { title: 'Delete Question', content: 'Are you sure you want to delete this question?' },
      };

      this.ngDialog.openConfirm(config).then(() => {
        // If this is the parent question
        // Then we make sure there are no children questions
        var childFound = false;

        if (!question.display_condition) {
          if (questions && questions.length) {
            questions.forEach(q => {
              if (q.display_condition) childFound = true;
            });
          }

          if (childFound) {
            return this.toastr.warning(
              "This parent question '" +
                question.text +
                "' has one or more children questions, please delete those first.",
            );
          }
        }

        this.QuestionnaireService.deleteQuestion(question.id)
          .then(() => {
            questions.splice(index, 1);
          })
          .catch(err => {
            return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not delete question.'));
          });
      });
    }

    updateQuestionPositions(sectionId, questionIds) {
      this.QuestionnaireService.updateQuestionPositions(sectionId, questionIds).catch(err => {
        return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update question ordering.'));
      });
    }

    /**
     * ANSWERS
     */

    addCombinationMapping(parentQuestion) {
      const initialDialog = this.ngDialog.open({
        template: 'app/views/services/questionnaire/combo-template.tpl.html',
        data: {
          parentQuestion,
          editing: false,
        },
        controller: 'ComboController',
        controllerAs: 'ctrl',
        closeByDocument: false,
        closeByEscape: false,
        preCloseCallback: (args = {}) => {
          if (args === '$closeButton') {
            const config = {
              template: 'app/components/modals/confirm.tpl.html',
              data: { title: 'Discard Combination', content: 'Are you sure you want to discard this combination?' },
            };
            this.ngDialog.openConfirm(config).then(() => {
              this.ComboQuestionService.clearSelected(parentQuestion.answers);
              this.ngDialog.closeAll();
            });
            return false;
          }
          return true;
        },
      });
      initialDialog.closePromise.then(expression => {
        if (_.isObject(expression.value)) {
          this.QuestionnaireService.postAnswerMappings(expression.value)
            .then(({ data }) => {
              if (!parentQuestion.additional_fields) {
                parentQuestion.additional_fields = [];
              }
              parentQuestion.additional_fields.push(data.data);
              this.ComboQuestionService.clearSelected(parentQuestion.answers);
              this.toastr.success('Answer combination added.');
            })
            .catch(err => {
              return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not add combination.'));
            });
        }
      });
    }
    addAnswer(parentQuestion) {
      let data;
      if (parentQuestion.type === 'select_combo' && this.LMNUK_1695) {
        data = {
          questionType: parentQuestion.type,
          answerDetailTypes: this.answerDetailTypes,
        };
      } else {
        data = {
          answerDetailTypes: this.answerDetailTypes,
          questionType: parentQuestion.type,
          warningLevel: [
            {
              name: 'Normal',
              type: 0,
            },
            {
              name: 'Information',
              type: 1,
            },
            {
              name: 'Warning',
              type: 2,
            }, //{ name: 'MD to Query', type: 4 },
            {
              name: 'MD to Query',
              type: 2.5,
            },
            {
              name: 'Danger',
              type: 3,
            },
          ],
        };
      }
      this.ngDialog.open({
        template: 'app/views/services/questionnaire/answer-form.tpl.html',
        data,
        controller: 'EditAnswerController',
        controllerAs: 'vm',
        preCloseCallback: (newAnswer = {}) => {
          if (_.isObject(newAnswer)) {
            if (parentQuestion.type === 'date') {
              const answer = parseFloat(newAnswer.text);
              if (isNaN(answer)) {
                this.toastr.error(`Please put numbers instead of "${newAnswer.text}".`);
                return;
              }
              if (answer < 0) {
                this.toastr.error('Please enter a number greater than zero.');
                return;
              }

              newAnswer = { ...newAnswer, treatment_copy: 'Days ago' };
            }
            //newAnswer.warning_level = parseInt(newAnswer.warning_level, 10);
            if (parentQuestion.type !== 'select_combo' && this.LMNUK_1695) {
              newAnswer.warning_level = parseFloat(newAnswer.warning_level);
            }
            this.QuestionnaireService.addAnswer(parentQuestion.id, newAnswer)
              .then(({ data }) => {
                parentQuestion.answers.push(data);
                this.updateRelationships();
              })
              .catch(err => {
                return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update add answer.'));
              });
          }
        },
      });
    }

    // editAnswer(oldAnswer) {
    //   oldAnswer.warning_level = oldAnswer.warning_level.toString();
    //   this.ngDialog.open({
    //     template: 'app/views/services/questionnaire/answer-form.tpl.html',
    //     controller: 'EditAnswerController',
    //     controllerAs: 'editAnswer',
    //     data: {
    //       editing: true,
    //       answerDetailTypes: this.answerDetailTypes,
    //       answer: Object.assign({}, oldAnswer),
    //       warningLevel: this.warningLevel,
    //     },
    //     preCloseCallback: (editedAnswer = {}) => {
    //       if (_.isObject(editedAnswer)) {
    //         //editedAnswer.warning_level = parseInt(editedAnswer.warning_level, 10);
    //         editedAnswer.warning_level = parseFloat(editedAnswer.warning_level);
    //         if(editedAnswer.hint === undefined){
    //             editedAnswer.hint = null;
    //         }
    //         this.QuestionnaireService
    //           .updateAnswer(oldAnswer.id, editedAnswer)
    //           .then(() => {
    //             Object.assign(oldAnswer, editedAnswer);
    //           })
    //           .catch((err) => {
    //             return this.toastr.error(
    //               this.Utils.getApiErrorMessage(err, 'Could not update edit answer.'),
    //             );
    //           });
    //       }
    //     },
    //   });
    // }
    editAnswer(oldAnswer, question) {
      this.ngDialog.open({
        template: 'app/views/services/questionnaire/answer-form.tpl.html',
        controller: 'EditAnswerController',
        controllerAs: 'vm',
        data: {
          editing: true,
          answerDetailTypes: this.answerDetailTypes,
          answer: Object.assign({}, oldAnswer),
          warningLevel: this.warningLevel,
          questionType: question.type,
        },
        preCloseCallback: (editedAnswer = {}) => {
          if (_.isObject(editedAnswer)) {
            //editedAnswer.warning_level = parseInt(editedAnswer.warning_level, 10);
            editedAnswer.warning_level = parseFloat(editedAnswer.warning_level);
            if (editedAnswer.hint === undefined) {
              editedAnswer.hint = null;
            }
            this.QuestionnaireService.updateAnswer(oldAnswer.id, editedAnswer)
              .then(() => {
                Object.assign(oldAnswer, editedAnswer);
              })
              .catch(err => {
                return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update edit answer.'));
              });
          }
        },
      });
    }

    checkQuestion(type) {
      return [
        'blood_pressure',
        'blood_pressure_uk',
        'bmi',
        'bmi_weight',
        'bmi_cocp_nor',
        'bmi_pde_pro',
        'bmi_map_lev1',
        'bmi_map_lev2',
        'bmi_map_uli',
        'bmi_wei',
        'bmi_wei_r',
        'bmi_meno',
        'info',
      ].includes(type);
    }

    deleteAnswer(answers, answer, index, question, questions) {
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: 'Delete Answer',
          content: 'Are you sure you want to delete this answer?',
        },
      };

      if (this.LMNUK_1695) {
        const isCombinationMappings = answer.type === 'answermappings';
        const isCombinationQuestion = question.type === 'select_combo';
        if (isCombinationQuestion) {
          let usedOption = [];
          const regexOperator = /\bAND|OR|and|or\b/g;
          const combinations = question.additional_fields;
          combinations.forEach(combination => {
            const expressionArray = combination.attributes.expression
              .replace(/[()!]/g, '')
              .split(regexOperator)
              .join(' ')
              .split(/\s+/);
            usedOption = [...new Set([...expressionArray, ...usedOption])];
          });
          if (usedOption.includes(answer.id.toString())) {
            return this.toastr.warning(
              `The answer you are tying to delete - ${answer.text} - is currently being used by an expression. Please delete or edit the expressions before trying again.`,
            );
          }
        }

        this.ngDialog.openConfirm(config).then(() => {
          // If this is a parent answer
          // Then we make sure this parent answer has no children questions assigned
          var hasChildAssigned = false;

          if (!question.display_condition) {
            if (questions && questions.length) {
              questions.forEach(q => {
                if (q.display_condition && q.display_condition.options && q.display_condition.options.length) {
                  q.display_condition.options.forEach(option => {
                    if (option == answer.id) hasChildAssigned = true;
                  });
                }
              });
            }

            if (hasChildAssigned) {
              return this.toastr.warning(
                "This parent answer '" +
                  answer.text +
                  "' has one or more children questions assigned, please edit those children questions and unselect this answer.",
              );
            }
          }

          this.QuestionnaireService.deleteAnswerNew(answer.id, isCombinationMappings)
            .then(() => {
              answers.splice(index, 1);
            })
            .catch(err => {
              return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not delete answer.'));
            });
        });
      } else {
        this.ngDialog.openConfirm(config).then(() => {
          // If this is a parent answer
          // Then we make sure this parent answer has no children questions assigned
          var hasChildAssigned = false;

          if (!question.display_condition) {
            if (questions && questions.length) {
              questions.forEach(q => {
                if (q.display_condition && q.display_condition.options && q.display_condition.options.length) {
                  q.display_condition.options.forEach(option => {
                    if (option == answer.id) hasChildAssigned = true;
                  });
                }
              });
            }

            if (hasChildAssigned) {
              return this.toastr.warning(
                "This parent answer '" +
                  answer.text +
                  "' has one or more children questions assigned, please edit those children questions and unselect this answer.",
              );
            }
          }

          this.QuestionnaireService.deleteAnswer(answer.id)
            .then(() => {
              answers.splice(index, 1);
            })
            .catch(err => {
              return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not delete answer.'));
            });
        });
      }
    }

    getQuestionnaireError() {
      let error;

      this.q.sections?.some((section, sectionIndex) => {
        error = this.getSectionError(section, sectionIndex);

        return (
          error ||
          section.questions?.some((question, questionIndex) => {
            error = this.getQuestionError(question, questionIndex, sectionIndex);
            return !!error;
          })
        );
      });

      return error;
    }

    getSectionError(section, sectionIndex) {
      let error;
      const hasQuestions = !!section.questions?.length;

      if (!hasQuestions) {
        error = {
          type: 'section',
          errorType: 'has no questions',
          elementText: section.title,
          sectionIndex: sectionIndex,
        };
      }
      return error;
    }

    getQuestionError(question, questionIndex, sectionIndex) {
      let error;
      const hasAnswers = !!question.answers?.length;

      if (!hasAnswers) {
        error = {
          type: 'question',
          errorType: 'has no answers',
          elementText: question.text,
          sectionIndex: sectionIndex,
          questionIndex: questionIndex,
        };
      }
      return error;
    }

    getQuestionnaireErrorText = questionnaireError => {
      const { type, errorType, sectionIndex, questionIndex, elementText } = { ...questionnaireError };

      return `Invalid questionnaire at section ${+sectionIndex + 1}${
        type === 'question' ? ', question ' + (+questionIndex + 1) : ''
      }. ${type[0].toUpperCase() + type.slice(1)} ${errorType}`;
    };

    isQuestionnaireInvalidWithShowError() {
      const questionnaireError = this.getQuestionnaireError();
      if (questionnaireError && this.q.sections?.length) {
        this.toastr.error(this.getQuestionnaireErrorText(questionnaireError));
      }
      return !!questionnaireError;
    }

    updateAnswerPositions(questionId, answerIds) {
      this.QuestionnaireService.updateAnswerPositions(questionId, answerIds).catch(() => {
        this.toastr.error('Failed to update answer ordering');
      });
    }

    formatDisplayedExpression(answers, expression) {
      const idsArray = expression.match(/\d+/g);
      const answersArr = [];
      answers.forEach(function (answer) {
        if (idsArray.includes(String(answer.id))) {
          answersArr.push(answer.text);
        }
      });
      return answersArr.join(' and ');
    }

    editCombinationMapping(oldCombination, question, status) {
      const idsArray = oldCombination.attributes.expression.match(/\d+/g);

      question.answers.forEach(function (answer) {
        answer.checked = idsArray.includes(answer.id.toString());
      });
      const { expressionText } = this.ComboQuestionService.formatMappingAnswers(question.answers);
      const initialDialog = this.ngDialog.open({
        template: 'app/views/services/questionnaire/combo-template.tpl.html',
        controller: 'ComboController',
        controllerAs: 'ctrl',
        closeByDocument: false,
        closeByEscape: false,
        data: {
          editing: true,
          answerDetailTypes: this.answerDetailTypes,
          parentQuestion: question,
          answer: oldCombination,
          status: `${status}`,
          expression: expressionText,
        },
        preCloseCallback: (args = {}) => {
          if (args === '$closeButton') {
            const config = {
              template: 'app/components/modals/confirm.tpl.html',
              data: { title: 'Discard Combination', content: 'Are you sure you want to discard this combination?' },
            };
            this.ngDialog.openConfirm(config).then(() => {
              this.ComboQuestionService.clearSelected(question.answers);
              this.ngDialog.closeAll();
            });
            return false;
          }
          return true;
        },
      });
      initialDialog.closePromise.then(args => {
        if (!args.value) return;
        const { prevCombination, newExpression } = args.value;
        this.ComboQuestionService.clearSelected(question.answers);
        if (
          prevCombination.attributes.expression === newExpression.data.attributes.expression &&
          prevCombination.attributes.status === newExpression.data.attributes.status
        )
          return;
        if (_.isObject(newExpression)) {
          this.QuestionnaireService.updateAnswerMappings(prevCombination.id, newExpression).then(({ data }) => {
            question.additional_fields.forEach((combination, idx) => {
              if (Number(data.data.id) === Number(combination.id)) {
                question.additional_fields.splice(idx, 1, data.data);
              }
            });
            this.toastr.success('Answer combination edited.');
          });
        }
      });
    }
  }

  QuestionnaireDetailController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    'ngDialog',
    'toastr',
    'Services',
    'QuestionnaireService',
    'Utils',
    'API_URL',
    '$q',
    'ComboQuestionService',
  ];
  angular.module('pims').controller('QuestionnaireDetailController', QuestionnaireDetailController);
})();
